import React from 'react'
import type { IconName } from '../../../shared/webcomponents/helpers/icons'

type Props = {
    onClick: () => void
    label: string
    iconName: IconName
}

/**
 * A dark button from this design: https://www.figma.com/file/NIH0lHcex2KBj19uf49Dm6/Knowledge-capture?type=design&node-id=1465-75417&mode=design&t=l7FjQHzU2OQylMb9-0
 *
 * Not clear if this is really a generic component or not.  Also consider:
 * * `../IconButton`
 * * `<zaptic-button/>`
 */
export function LabelledIconButton({ onClick, label, iconName }: Props) {
    return (
        <button type="button" className="AppCore__ui__LabelledIconButton" onClick={onClick}>
            <span className="AppCore__ui__LabelledIconButton__icon">
                <zaptic-icon icon-name={iconName} />
            </span>

            <span className="AppCore__ui__LabelledIconButton__label">{label}</span>
        </button>
    )
}
